export function isLocalHost() {
    if (window?.location?.hostname === "localhost" || window?.location?.hostname === "127.0.0.1")
        return true
    return false
}

export function isStaging() {
    if (window?.location?.hostname === "rr-dev.zesty.xyz")
        return true
    return false
}